import { Fragment, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AuthContext } from '../../Contexts/AuthContext';
import { CompanyContext } from '../../Contexts/CompanyContext';
import { IResponseProps } from '../../Interfaces/IResponseProps';
import { SortDesc, SortYear } from '../../Utils/SortYear';
import { IndebtednessModel } from '../../Models/IndebtednessModel';
import { AvailabilityModel } from '../../Models/AvailabilityModel';
import { EbtidaModel } from '../../Models/EbtidaModel';
import { IPercentagesProps } from '../../Interfaces/IPercentagesProps';
import { IEbtidaResultProps } from '../../Interfaces/IEbtidaResultProps';
import { IGuaranteeProps } from '../../Interfaces/IGuaranteeProps';
import { ExternalRoles } from '../../Static/Roles';
import { formatOnlyDate } from '../../Utils/DateFormat';
import { FaTrash } from 'react-icons/fa';
import { AnalysisModel, VersionViewModel } from '../../Models/AnalysisModel';
import { CreateAnalysisCopyAPI, CreateAnalysisVersion, DeleteWIPAnalysisAPI, GetAllAnalysis, GetAllAnalysisByVersion, GetAllVersionsByCompanyAPI, GetAnalysisPercentages, PutAnalysisConcludedAPI, DeleteAnalysisVersionAPI, GetShowWarningFilesAPI } from '../../API/AnalysisAPI';
import Loader from '../../Components/Shared/Loader';
import useCan from '../../Hooks/useCan';
import useModal from '../../Hooks/useModal';
import useLoading from '../../Hooks/useLoading';
import UploadFilesComponent from '../../Components/FinancialAnalysis/UploadFilesComponent';
import CardHeader from '../../antd/components/CardHeader';
import StartInfosToAnalysis from '../../Components/FinancialAnalysis/StartInfosToAnalysisComponent';
import TableCreateAnalysis from '../../Components/FinancialAnalysis/TableCreateAnalysisComponent';
import PaginationTabHeader from '../../Components/Shared/PaginationTabHeader';
import PotentialValueComponent from '../../Components/FinancialAnalysis/PotentialValueComponent';
import TablePercentagesComponent from '../../Components/FinancialAnalysis/TablePercentagesComponent';
import EbtidaAnalysisComponent from '../../Components/FinancialAnalysis/EbtidaAnalysisComponent';
import GuaranteesComponent from '../../Components/FinancialAnalysis/GuaranteesComponent';
import IsFinanciableComponent from '../../Components/FinancialAnalysis/IsFinanciableComponent';
import ObservationComponent from '../../Components/FinancialAnalysis/ObservationComponent';
import ModalDeleteMassive from '../../Components/Shared/ModalDeleteMassive';
import ModalCreateVersionComponent from '../../Components/FinancialAnalysis/ModalCreateVersionComponent';
import { FundProjectionScreenOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import './styles.css';



const FinancialAnalysis = () => {
    const canNotView = useCan({ rolesCan: ["Trainee", "Comercial", "Consultant", "Internal", "HumanResources", "TechnicianLimited", "Technician", "Dossie", "Financial"] });
    const masterCanNotView = useCan({ rolesCan: ["Master"] })
    const FINNCanNotView = useCan({ rolesCan: ["FINNSeguros - Extern"] })
    const canViewHistoricFinancialAnalysis = useCan({ rolesCan: ["Consultant", "Administrator", "Master"] })
    const { showModal, toggleShowModal } = useModal();
    const { showModal: showModalDelete, toggleShowModal: toggleShowModalDelete } = useModal();
    const { company, getCompany } = useContext(CompanyContext);
    const { loading, toggleLoading } = useLoading();
    const { userEmail } = useContext(AuthContext);
    const [pag, setPag] = useState<number>(0);
    const [key, setKey] = useState<number>(0);
    const [analysis, setAnalysis] = useState<AnalysisModel[]>([]);
    const [rowsEbtida, setRowsEbtida] = useState<EbtidaModel[]>([]);
    const [rowsIndebtedness, setRowsIndebtedness] = useState<IndebtednessModel[]>([]);
    const [rowsAvailability, setRowsAvailability] = useState<AvailabilityModel[]>([]);
    const [valueHasChanged, setValueHasChanged] = useState<boolean>(true);
    const [yearsCreated, setYearsCreated] = useState<number[]>([]);
    const [PL, setPL] = useState<number>(0);
    const [totalAssets, setTotalAssets] = useState<number>(0);
    const [grossRevenue, setGrossRevenue] = useState<number>(0);
    const [netWorth, setnetWorth] = useState<number>(0);
    const [hasAlert, setHasAlert] = useState<boolean>(true);
    const [defaultPotentialValue, setDefaultPotentialValue] = useState<number>(0);
    const [justificationDefault, setJustificationDefault] = useState<string>("");
    const [analysisId, setAnalysisId] = useState<string>("");
    const [observation, setObservation] = useState<string>("");
    const [rowPercentages, setRowPercentages] = useState<IPercentagesProps[]>([]);
    const [rowGuarantees, setRowGuarantees] = useState<IGuaranteeProps[]>([]);
    const [rowEbtidaResults, setEbtidaResults] = useState<IEbtidaResultProps[]>([]);
    const [hasConcluded, setHasConcluded] = useState<boolean>(false);
    const [deleteVersion, setDeleteVersion] = useState<boolean>(false);
    const [currentVersion, setCurrentVersion] = useState<number>(-1);
    const [createMethod, setCreateMethod] = useState<string>("");
    const [deleteVersionMethod, setDeleteVersionMethod] = useState<string>("");
    const [analysisVersionVO, setAnalysisVersionVO] = useState<VersionViewModel[]>([] as VersionViewModel[]);

    const createRows = () => {
        toggleLoading(true);

        var data = SortYear(analysis);

        var ebtidaArray: EbtidaModel[] = [];
        var availabilityArray: AvailabilityModel[] = [];
        var indebtednessArray: IndebtednessModel[] = [];
        var yearsCreatedArray: number[] = [];

        data.map((a: any) => {
            a.ebtida['year'] = a.year;
            a.availability['year'] = a.year;
            a.indebtedness['year'] = a.year;

            ebtidaArray.push(a.ebtida);
            availabilityArray.push(a.availability);
            indebtednessArray.push(a.indebtedness);
            yearsCreatedArray.push(a.year);
        });

        setRowsEbtida(ebtidaArray);
        setRowsAvailability(availabilityArray);
        setRowsIndebtedness(indebtednessArray);
        setYearsCreated(yearsCreatedArray);

        toggleLoading(false);
    }

    const getVersionList = () => {
        const options = [];

        if (analysisVersionVO.length > 0) {
            for (var i = 0; i <= analysisVersionVO.length - 1; i++) {
                options.push(<option selected={analysisVersionVO[i].version === analysisVersionVO.length - 1}
                    value={i} key={i}>V{i + 1 + ' - ' + formatOnlyDate(analysisVersionVO[i].date)}</option>);
            }
        } else {
            options.push(<option selected={true} value="" key={0}>--</option>)
        }
        return options;
    }

    const getAllVersionsByCompany = async () => {
        try {
            toggleLoading(true);

            await GetAllVersionsByCompanyAPI(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setAnalysisVersionVO(resp.data);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    const createAnalysisCopy = async () => {
        try {
            toggleLoading(true);

            await CreateAnalysisCopyAPI(company.id, userEmail, currentVersion).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setValueHasChanged(true);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    const handleVersion = async (e: any) => {
        setCurrentVersion((c) => Number(e.target.value));
        getAllAnalysisByVersion(e.target.value);
    }

    const getAllAnalysisByVersion = async (version: number) => {
        try {
            toggleLoading(true);
            await GetAllAnalysisByVersion(company.id, version).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setRowsEbtida([]);
                    setRowsAvailability([]);
                    setRowsIndebtedness([]);
                    setYearsCreated([]);
                    setPag(0);
                    setAnalysis(resp.data);
                    if (resp.data[0]) {
                        setHasConcluded(resp.data[0].concluded);
                    }
                }
            }).finally(() => {
                setValueHasChanged(false);
                toggleLoading(false);
            })
        } catch (error: any) {
            setValueHasChanged(false);
            toggleLoading(false);
            toast.error(error);
        }

    }

    const getMostRecentAnalysis = async () => {
        try {
            toggleLoading(true);
            await GetAllAnalysis(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setAnalysis(resp.data);
                    if (resp.data[0]) {
                        setCurrentVersion(resp.data[0].versionQuantity ?? 0);
                        setHasConcluded(resp.data[0].concluded);
                    } else {
                        setCurrentVersion(-1);
                        setHasConcluded(false);
                        getCompany(company.id);
                    }
                }
            }).finally(() => {
                setValueHasChanged(false);
                toggleLoading(false);
            })
        } catch (error: any) {
            setValueHasChanged(false);
            toggleLoading(false);
            toast.error(error);
        }
    }

    const getPercentToGuarantee = () => {
        const guarantees = company.guaranteeType?.split(",") ?? "";
        let percent = 1;

        if (guarantees.includes("credittitle")) {
            percent = 1.7;
        } else if (guarantees.includes("properties")) {
            percent = 1.3;
        } else if (guarantees.includes("suretyBond")) {
            percent = 1.05;
        } else if (guarantees.includes("guaranteeFund")) {
            percent = 0.6;
        }

        return percent;
    }

    const getPercentages = async (ebtidaId: string, indebtednessId: string, availabilityId: string, id: string) => {
        try {
            toggleLoading(true);
            await GetAnalysisPercentages(ebtidaId, indebtednessId, availabilityId, id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setRowPercentages([resp.data]);
                    setHasAlert(!resp.data.isAccept);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    const getEbtidaResults = (ebtidaResult: number, value: number) => {
        var ebtidaFourTimes = ebtidaResult * 4;
        var resultEbtidaAnalysis = ebtidaFourTimes - value;
        setEbtidaResults([{
            ebtidaFourTimes: "R$ " + ebtidaFourTimes.toFixed(2).replace(".", ","),
            financialValue: "R$ " + value.toFixed(2).replace(".", ","),
            resultEbtidaAnalysis: "R$ " + resultEbtidaAnalysis.toFixed(2).replace(".", ","),
            hasImpediments: resultEbtidaAnalysis < 0 ? "Sim, recomenda-se diminuir o valor do projeto!" : "Sem impedimentos!"
        }]);
    }

    const getGuarantees = (fixedAssetValue: number, value: number) => {
        let percentage = getPercentToGuarantee();

        let financialValuePercent = value * percentage;
        setRowGuarantees([{
            fixedAssetValue: "R$ " + fixedAssetValue.toFixed(2).replace(".", ","),
            financialValue: "R$ " + value.toFixed(2).replace(".", ","),
            financialValuePercent: "R$ " + financialValuePercent.toFixed(2).replace(".", ","),
            immobilizedGuarantee: financialValuePercent <= fixedAssetValue ? "Sim" : "Não"
        }]);
    }

    const postAnalysisVersion = async () => {
        if (company.isAnalysisConcluded == null || company.isAnalysisConcluded == undefined || company.isAnalysisConcluded == false) {
            setFinancialAnalysisConcluded(true);
        }
        try {
            toggleLoading(true);

            await GetShowWarningFilesAPI(company.id, yearsCreated).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    let response = resp.data;
                    if (response == true) {
                        toast.warning("Atenção, Versão de Análise criada sem DRE ou Balanço Patrimonial");
                    }
                }
            });

            await CreateAnalysisVersion(company.id, userEmail, currentVersion).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Análise financeira concluída com sucesso!");
                    setValueHasChanged(true);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }

    }

    const updateAllValues = () => {
        var yearsDesc = SortDesc(yearsCreated);
        var analyst = analysis.find((a: AnalysisModel) => a.year === yearsDesc[pag]);

        if (analyst) {
            setDefaultPotentialValue(analyst.potentialValue);
            setJustificationDefault(analyst.justification);

            var eb = analyst.ebtida;
            var ind = analyst.indebtedness;
            var av = analyst.availability;

            setPL(ind.netWorth);
            setTotalAssets(ind.totalAssets);
            setnetWorth(ind.netWorth);

            getPercentages(eb.id, ind.id, av.id, analyst.id);
            getEbtidaResults(eb.ebtidaResult, analyst.potentialValue);
            getGuarantees(av.netFixedAssets, analyst.potentialValue);

            setObservation(analyst.observation);
            setAnalysisId(analyst.id);
            setGrossRevenue(eb.grossRevenue);
        }
    }

    const setFinancialAnalysisConcluded = async (value: boolean) => {
        try {
            toggleLoading(true);

            await PutAnalysisConcludedAPI(company.id, value, userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    getCompany(company.id);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const deleteWIPAnalysis = async () => {
        try {
            toggleLoading(true);

            await DeleteWIPAnalysisAPI(company.id, currentVersion).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Análise deletada com sucesso!");
                    setDeleteVersionMethod("");
                    setDeleteVersion(false);
                }
            }).finally(() => {
                setValueHasChanged(true);
                toggleLoading(false);
            })
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    const deleteAnalysisVersion = async () => {
        try {
            toggleLoading(true);

            await DeleteAnalysisVersionAPI(company.id, currentVersion).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Versão de Análise deletada com sucesso!");
                    setDeleteVersionMethod("");
                    setDeleteVersion(false);
                }
            }).finally(() => {
                setValueHasChanged(true);
                toggleLoading(false);
            })
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    useEffect(() => {
        if (yearsCreated.length > 0) {
            updateAllValues();
        }
    }, [pag, yearsCreated]);

    useEffect(() => {
        if (valueHasChanged) {
            setRowsEbtida([]);
            setRowsAvailability([]);
            setRowsIndebtedness([]);
            setYearsCreated([]);
            getAllVersionsByCompany();
            getMostRecentAnalysis();
        }
    }, [valueHasChanged]);

    useEffect(() => {
        if (analysis.length > 0) {
            createRows();
        }
    }, [analysis]);

    useEffect(() => {
        if (createMethod == "blank") {
            setRowsEbtida([]);
            setRowsAvailability([]);
            setRowsIndebtedness([]);
            setYearsCreated([]);
            setCurrentVersion(currentVersion + 1);
            setHasConcluded(false);
            setCreateMethod("");
        } else if (createMethod == "historic") {
            createAnalysisCopy();
        }
    }, [createMethod]);

    useEffect(() => {
        if (deleteVersion && deleteVersionMethod == "wip") {
            deleteWIPAnalysis();
        } else if (deleteVersion && deleteVersionMethod == "historic") {
            deleteAnalysisVersion();
        }
    }, [deleteVersion]);
    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <ModalCreateVersionComponent
                toggleShow={toggleShowModal}
                show={showModal}
                setCreateMethod={setCreateMethod}
            />
            <ModalDeleteMassive
                show={showModalDelete}
                setResponse={setDeleteVersion}
                toggleShow={toggleShowModalDelete}
            />
            <CardHeader
                pageName={"Construção de Análise Financeira"}
                hasPageBefore={false}
            />
            <div className='card-body'>

                <UploadFilesComponent
                    companyId={company.id}
                    toggleLoading={toggleLoading}
                    userEmail={userEmail}
                    FINNCanNotView={FINNCanNotView}
                    defaultFinancialValue={company.approximateValue.toString()}
                    canNotView={canNotView}
                />
                {!FINNCanNotView && <>
                    {/* <StartInfosToAnalysis
                        toggleLoading={toggleLoading}
                        defaultGuarantee={company.guaranteeType?.split(",") ?? []}
                        defaultOtherText={company.guaranteeOther}
                        setValueHasChanged={setValueHasChanged}
                        defaultStates={company.investedStates?.split(",") ?? []}
                        operationDefault={company.operationRefusedObservation}
                        renegotiationDefault={company.renegotiationObservation}
                        canNotView={canNotView}
                        userEmail={userEmail}
                    /> */}
                    {(currentVersion >= 0) ?
                        <Fragment>
                            {canViewHistoricFinancialAnalysis &&
                                <div className='card card-header rounded-3 mt-4 mb-3 flex-row d-flex align-items-center justify-content-between'>
                                    <div className='font-weight-bold text-nowrap'>Histórico de Análise Financeira</div>
                                    <div className='d-flex align-items-center'>
                                        <span className='me-3 w-100 text-nowrap'>Selecione uma versão:</span>

                                        {hasConcluded ?
                                            <Fragment>
                                                <select
                                                    onChange={(e: any) => { handleVersion(e) }}
                                                    className="form-select w-100"
                                                >
                                                    {
                                                        getVersionList()
                                                    }
                                                </select>

                                                <div className='d-flex align-items-center'>
                                                    <Button
                                                        //variant="contained"
                                                        className='btn btn-primary w-100 ms-2 text-nowrap'
                                                        onClick={toggleShowModal}
                                                    >
                                                        Criar Nova Versão
                                                    </Button>
                                                    <Button
                                                        //startIcon={<FaTrash />}
                                                        //size="medium"
                                                        onClick={() => { setDeleteVersionMethod("historic"); toggleShowModalDelete() }}
                                                        className="btn btn-secondary w-25 h-100 ms-2"
                                                    />


                                                </div>
                                            </Fragment>
                                            :
                                            <span className='text-nowrap'>Análise em Andamento</span>
                                        }
                                    </div>
                                </div>
                            }
                            <TableCreateAnalysis
                                companyId={company.id}
                                userEmail={userEmail}
                                setValueHasChanged={setValueHasChanged}
                                yearsCreated={yearsCreated}
                                rowsEbtida={rowsEbtida}
                                rowsIndebtedness={rowsIndebtedness}
                                rowsAvailability={rowsAvailability}
                                setRowsAvailability={setRowsAvailability}
                                setRowsEbtida={setRowsEbtida}
                                setRowsIndebtedness={setRowsIndebtedness}
                                toggleLoading={toggleLoading}
                                canNotView={canNotView}
                                currentVersion={currentVersion}
                                lastVersion={(analysis.length && analysis[0].versionQuantity) ?? 0}
                                hasConcluded={hasConcluded}
                            />

                            {yearsCreated.length > 0 &&
                                <div className='mt-5'>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <PaginationTabHeader setPag={setPag} pag={pag} setKey={setKey} keyDefault={key} tabs={SortDesc(yearsCreated)} />
                                    </div>
                                    <div className='pagination-tab-body p-3' key={key}>
                                        <PotentialValueComponent
                                            toggleLoading={toggleLoading}
                                            setValueHasChanged={setValueHasChanged}
                                            analysisId={analysisId}
                                            defaultPotentialValue={defaultPotentialValue}
                                            canNotEdit={canNotView}
                                            userEmail={userEmail}
                                            companyId={company.id}
                                            totalAssets={totalAssets}
                                            grossRevenue={grossRevenue}
                                            netWorth={netWorth}
                                            hasConcluded={hasConcluded}
                                        />
                                        {(!canNotView && !masterCanNotView) &&
                                            <Fragment>
                                                <TablePercentagesComponent rowPercentages={rowPercentages} />
                                                <EbtidaAnalysisComponent rowEbtidaResults={rowEbtidaResults} />
                                                <GuaranteesComponent rowGuarantees={rowGuarantees} percentage={getPercentToGuarantee()} />
                                            </Fragment>
                                        }
                                        {!masterCanNotView &&
                                            <div className='container-financial-potency'>
                                                <div className='form-control h-100 container-text-financial w-50 border-0 rounded-0 d-flex align-items-center'>
                                                    <span className='font-weight-bold'>Modalidade de Financiamento</span>
                                                </div>
                                                <div className='form-control d-flex align-items-center h-100 border-0 rounded-0 back-light'>
                                                    <span className='fw-bold'>{grossRevenue == 0 ? "Não há informações no momento!" : grossRevenue < 300000000 ? "Verificar valor do financiamento para saber se será operação direta" : "Operação Direta por causa do faturamento"}</span>
                                                </div>
                                            </div>
                                        }
                                        {!masterCanNotView &&
                                            <ObservationComponent
                                                observation={observation}
                                                canNotEdit={canNotView}
                                                toggleLoading={toggleLoading}
                                                analysisId={analysisId}
                                                userEmail={userEmail}
                                                companyId={company.id}
                                                hasConcluded={hasConcluded}
                                            />
                                        }
                                        {!masterCanNotView &&
                                            <IsFinanciableComponent
                                                key={key}
                                                pl={PL}
                                                hasAlert={hasAlert}
                                                justificationDefault={justificationDefault}
                                                toggleLoading={toggleLoading}
                                                analysisId={analysisId}
                                                setValueHasChanged={setValueHasChanged}
                                                canNotEdit={canNotView}
                                                userEmail={userEmail}
                                                companyId={company.id}
                                                financialValue={company.approximateValue}
                                                potentialValue={defaultPotentialValue}
                                                hasConcluded={hasConcluded}
                                            />
                                        }
                                        {!hasConcluded &&
                                            <div className='d-flex align-items-center w-100'>
                                                <Button
                                                    //variant="contained"
                                                    onClick={postAnalysisVersion}
                                                    className="btn btn-primary w-100 mt-3 me-2"
                                                >
                                                    Finalizar análise
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => { setDeleteVersionMethod("wip"); toggleShowModalDelete() }}
                                                    className="btn btn-secondary w-25 mt-3 ms-2"
                                                >
                                                    <FaTrash className='white-icon' />
                                                </Button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </Fragment>
                        :
                        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                            <Button
                                type="primary"
                                className="custom-button mt-4"
                                onClick={() => {
                                    setCreateMethod("blank");
                                }}
                            >
                                <div className="button-content">
                                    <div className="icon-circle">
                                        <FundProjectionScreenOutlined style={{ fontSize: '24px' }} />
                                    </div>
                                    <span className="button-text">Criar Análise Financeira</span>
                                </div>
                            </Button>
                        </div>
                    }
                </>}

            </div>
        </div>
    );
}

export default FinancialAnalysis;